import { render, staticRenderFns } from "./t-table.vue?vue&type=template&id=39537702&"
import script from "./t-table.vue?vue&type=script&lang=js&"
export * from "./t-table.vue?vue&type=script&lang=js&"
import style0 from "./t-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports